<script setup>
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import { useAlert } from 'dashboard/composables';

defineProps({
  src: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change', 'delete']);

const updateProfilePicture = e => {
  emit('change', e);
};

const deleteProfilePicture = () => {
  emit('delete');
};

const handleUploadError = (error) => {
  useAlert(error.message, {type: 'error'});
};

</script>

<template>
  <div class="flex flex-col gap-2">
    <Avatar
      :src="src || ''"
      :name="name || ''"
      :size="80"
      :camera-icon-size="24"
      :camera-icon-padding="2"
      :rounded-full="true"
      allow-upload
      @upload="updateProfilePicture"
      @delete="deleteProfilePicture"
      @error="handleUploadError"  
    />
  </div>
</template>
